<template>
  <div class="modal fade" tabindex="-1" id="toolsModal" aria-labelledby="toolsModalLabel" aria-hidden="true"
       data-bs-backdrop="static" data-bs-keyboard="false">
    <div class="modal-dialog">
      <div class="modal-content" v-if="visibleModalTools">
        <div class="modal-header text-center">
          <h1 class="modal-title fs-5 text-center">Ferramentas</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                  @click="hideModalTools"></button>
        </div>
        <div class="modal-body mb-3">
          <p class="modal-text">
            <strong>Canais de comunicação alternativos:</strong>
          </p>
          <!-- <p class="text-black-50">Qualquer dificuldade entre em contato com nosso suporte.</p> -->
          <div class="container mt-2 mb-4 d-grid gap-2">
            <button class="btn btn-outline-primary btn-tools mb-2" @click="openCall()">
              <i class="bi bi-camera-video icon-margin"></i> ABRIR UMA CHAMADA DE VÍDEO
            </button>
            <button class="btn btn-outline-primary btn-tools mb-2" @click="changeChat()"
                    v-if="Report.protocol_update_info.chat_type !== 'desk'">
              <i class="bi bi-chat-left-dots icon-margin"></i> ESTOU COM PROBLEMAS NO CHAT
            </button>
          </div>

          <p class="modal-text">
            <strong>Aprendizagem:</strong>
          </p>
          <div class="container mt-2 d-grid gap-2">
            <button class="btn btn-outline-primary btn-tools mb-2" @click="downloadManualPEP()">
              <i class="bi bi-arrow-bar-down icon-margin"></i>BAIXAR MANUAL DO PEP
            </button>
            <button class="btn btn-outline-primary btn-tools mb-2" @click="openSuportWhatsapp()">
              <i class="bi bi-people icon-margin"></i> FALAR COM O TIME DE TREINAMENTO
            </button>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" @click="hideModalTools">Fechar
            janela
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters, mapActions} from "vuex";

export default {
  props: {
    visibleModalTools: Boolean
  },
  computed: {
    ...mapGetters({
      User: "StateUser",
      Report: "StateReport"
    }),
  },
  data() {
    return {
    }
  },
  methods: {
    ...mapActions(["ChangeChat"]),
    ...mapActions(["MessageMeet"]),

    hideModalTools() {
      this.$emit("hideModalTools")
    },
    async changeChat() {
      try {
        await this.ChangeChat({report: this.Report, chat_type: 'desk'});
        window.Hyperflow.initFlow('2WSfobCky')
        try {
          window.Hyperflow.close()
        } catch (er) {
          console.log("Erro ao fechar o chat");
        }
        this.openTab();
      } catch {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },
    async openCall() {
      try {
        window.open(this.User.meet_url, 'Meet');
        let info = {
          phone: this.Report.protocol_update_info.requester_phone,
          url: this.User.meet_url
        }
        if (info.phone !== "" && info.phone !== null) {
          await this.MessageMeet(info)
        } else {
          this.$toast.error('Falha ao enviar mensagem,  tente novamente.', {
            timeout: 3000,
            closeOnClick: true
          });
        }
      } catch {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },
    async downloadManualPEP() {
      try {
        const pdfUrl = "https://grpetliq4fgm.objectstorage.sa-saopaulo-1.oci.customer-oci.com/n/grpetliq4fgm/b/doc4doc-public/o/assets%2FGuia%20do%20M%C3%A9dico%20Especialista%20DOC4DOC.pdf";
        const link = document.createElement('a');
        link.href = pdfUrl;
        link.target = '_blank';
        link.download = 'Guia do Médico Especialista DOC4DOC';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },
    async openSuportWhatsapp() {
      try {
        const whatsappUrl = "https://api.whatsapp.com/send/?phone=5511915725562&text=Ol%C3%A1+preciso+de+ajuda";
        const link = document.createElement('a');
        link.href = whatsappUrl;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } catch {
        this.$toast.error('Ocorreu um erro, tente novamente.', {
          timeout: 3000,
          closeOnClick: true
        });
      }
    },
    openTab() {
      window.open('https://desk.hyperflow.global/', 'HyperflowDesk');
    },
  },
};
</script>

<style>
.btn-tools {
  /* color: #6200EE !important;; */
  /* border-color: #6200EE !important; */
  /* font-family: "Roboto", sans-serif !important; */
  font-size: 14px !important;
  font-weight: bold !important;
  border-width: 2px !important;
}
.icon-margin{
  margin-right: 5px;
}
</style>
